import { render, staticRenderFns } from "./privacyPolicyForWoMens.vue?vue&type=template&id=bcf98cd2&scoped=true"
import script from "./privacyPolicyForWoMens.vue?vue&type=script&lang=ts"
export * from "./privacyPolicyForWoMens.vue?vue&type=script&lang=ts"
import style0 from "./privacyPolicyForWoMens.vue?vue&type=style&index=0&id=bcf98cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf98cd2",
  null
  
)

export default component.exports